import {
  checkUsername,
  checkUsernameSchema,
} from '@/lib/server-functions/check-username';
import { useMutation } from '@tanstack/react-query';
import z from 'zod';

export const useCheckUsername = () => {
  return useMutation({
    mutationFn: async (payload: z.infer<typeof checkUsernameSchema>) => {
      return await checkUsername({ data: payload });
    },
  });
};
